class constant {
  constructor() {
    /*系统基础*/
    // 性别
    this.GENDER = { GENTLEMEN: '先生', LADY: '女士' }
    // 位置
    this.LOCATION = { CHINA: '中国大陆', PROVINCE: '省份', CITY: '城市', COLLEGE: '学校', CAMPUS: '校区', AREA: '区域', BUILDING: '楼宇' }

    /*设备模块*/
    // 优惠券
    this.COUPON = { RECOUP: '补偿券', VIP: 'VIP尊享券' }
    // 设备维护类型
    this.EQP_MAINT_TYPE = { DISINFECT: '消毒', CLEAN: '清洗' }
    // 设备状态
    this.EQP_STATUS = {
      FREE: '空闲',
      RESERVE: '预约中',
      STARTING: '启动中',
      WORKING: '运行中',
      BREAKDOWN: '故障',
      OFFLINE: '离线',
      UPGRADING: '升级中',
      NOSERVICE: '停用'
    }
    // 设备类型
    this.EQP_TYPE = {
      WASHING: '洗衣机',
      SHOES: '洗鞋机',
      DRY: '烘干机',
      BLOWER: '吹风机',
      WATER: '直饮水',
      VENDOR: '自助售货机',
      STEAMER: '挂烫机',
      HEATER: '热水器'
    }
    // 设备运行状态
    this.EQP_RUN_STATUS = {
      WAIT_PAY: '待支付',
      WAIT_START: '待启动',
      STARTING: '启动中',
      WORKING: '运行中',
      WORK_BREAKDOWN: '运行故障',
      CANCEL: '取消',
      FINISH: '完成'
    }
    // 模块公司
    this.MODULE_COMPANY = { KBS: '卡博士', HBKJ: '和邦科技', XY: '小鸭', SME: '思迈尔', HK: '宏卡' }
    // 模块类型
    this.MODULE_TYPE = { PW: '密码启动', PREPAID: '预付费', ONLINE: '在线启动', BLUETOOTH: '蓝牙启动' }
    // 运行模式类型
    this.WORK_MODE_TYPE = { MAIN_MODE: '主模式', ADDIT_MODE: '附加模式' }

    /*外卖*/
    // 外卖订单状态：
    this.TAKEOUT_ORDER_STATUS = {
      WAIT_PAY: '待支付',
      WAIT_ACCEPT: '待商家接单',
      MAKE: '菜品制作中',
      DELIVERING: '配送中',
      DELIVERIED: '已送达',
      INIT_CANCEL: '发起取消',
      CANCEL: '已取消'
    }

    /*订单*/
    // 评价状态
    this.EVAL_STATUS = { UNEVALUABLE: '不可评价', WAIT_EVALUATE: '待评价', EVALUATED: '已评价' }
    // 下单渠道
    this.ORDER_CHANNEL = { WECHAT: '微信公众号', APP: 'APP', WECHAT_MINIAPP: '微信小程序' }
    // 订单类型
    this.ORDER_TYPE = { WAIT_PAY: '待支付', IN_PROCESS: '进行中', FINSH: '已完成', CANNEL: '已取消' }
    // 支付渠道
    this.PAY_CHANNEL = {
      WECHAT: '微信支付',
      ALIPAY: '支付宝',
      BALANCE: '平台余额',
      STORE_MEMBER_BALANCE: '店铺余额',
      ONCARD: '一卡通',
      FREE: '无需支付'
    }
    // 支付状态
    this.PAY_STATUS = { NOT_PAY: '未支付', PAID: '已支付', REFUNDING: '退款中', REFUNDED: '已退款' }
    // 分成状态
    this.SHARED_STATUS = { NOT_SHARING: '不分账', IN_SHARING: '分账中', FINISH_SHARING: '分账完成' }
    // 业务类型
    this.ORDER_SERVICE_TYPE = {
      NO: '无业务类型',
      COMMON: '公用',
      BASIC: '基础',
      EQUIPMENT: '自助设备',
      BALANCE: '余额充值',
      VIP: '会员开通',
      TAKEOUT: '外卖',
      RUN_ERRAND: '跑腿',
      WASH: '洗车',
      LAUNDRY: '取送洗衣',
      STORE_COLLECTION: '店铺收款',
      STORE_MEMBER_BALANCE: '店铺会员余额',

      REPAIR: '维修',
      STUDENT: '学生',
      DORM: '宿舍',
      COMPLAINT: '投诉',
      BOOKING_PLATFORM: '预约',
      WAREHOUSE: '仓库',
      STORE: '店铺'
    }
    // 业务类型
    this.DORM_STATUS = { UNUSED: '空闲', LIVING: '入住', MEET: '住满' }

    /**报修 */
    this.REPAIR_STATUS = {
      WAIT_ASSIGN: '待派工',
      REPAIRING: '维修中',
      HUAGIN: '挂起中',
      FINISHED: '已完结',
      CANCELED: '已取消',
      EVALUATED: '已评价',
      TODISPATCHWORKERS: '待接单',
      RETURN: '退回'
    }
    this.REPAIR_FINISH_STATUS = { COMPLETE: '完成', OUT_SCOPE: '超出范围', RESTS: '其他' }

    /**
     * 取送洗衣
     */
    // 取送洗衣订单状态
    this.LAUNDRY_ORDER_STATUS = {
      WAIT_CONFIRM: '待上门确认',
      WAIT_PAY: '待支付',
      WAIT_PICKUP: '待取件',
      IN_WASH: '清洗中',
      COMPLETED: '已完成',
      CANCELED: '已取消'
    }

    // 跑腿订单状态
    this.ERRAND_ORDER_STATUS = {
      TOBEPAID: '待支付',
      PENDINGORDER: '待抢单',
      TOBEDELIVERED: '进行中',
      COMPLETED: '已完成',
      USERCANCELLED: '已取消'
    }

    // 报修功能是否开启分类
    this.REPAIR_FUNCTION_TYPE = {
      ORDERS: '接单',
      SMSNOTIFICATION: '短信提醒',
      TIMEDTASK: '定时任务',
      IS_UPLOAD_PIC: '报修图片是否必选'
    }

    // 学工审批状态
    this.APPROVAL_STATUS = {
      NEW: { label: '新创建', color: '#a3a3a3' },
      RUNNING: { label: '审批中', color: '#4279FA' },
      TERMINATED: { label: '被终止', color: '#FF7930' },
      COMPLETED: { label: '完成', color: '#54BF54' },
      CANCELED: { label: '取消', color: '#a3a3a3' }
    }
  }
}

export default constant



// WEBPACK FOOTER //
// ./src/assets/js/constant.js